import { usePecField } from 'components/form'
import { PrivateRoute } from 'components/route'
import { MChatRiscoEnum } from 'graphql/types.generated'
import { Fragment, useRef } from 'react'
import { useRouteMatch } from 'react-router'
import { NIVEL_SUPERIOR } from 'types/NivelCbo'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoAplicacaoForm } from '../consulta-seguimento-aplicacao/ConsultaSeguimentoAplicacaoForm'
import {
  CONSULTA_SEGUIMENTO_URL_MODAL,
  ConsultaSeguimentoFieldModel,
  ConsultaSeguimentoViewModel,
  MChatPerguntaPrincipal,
} from '../model-consultaSeguimento'
import { calculateResultadoConsultaSeguimento, getMChatForConsultaSeguimento } from '../utils-consultaSeguimento'
import { ConsultaSeguimentoFieldAccordionSection } from './ConsultaSeguimentoFieldAccordionSection'

interface ConsultaSeguimentoFieldProps {
  name: MetaPath<ConsultaSeguimentoFieldModel>
  valuesAtendimentoAnterior: ConsultaSeguimentoViewModel | null
  mChatAtualRisco: MChatRiscoEnum | undefined
  mChatAnteriorRisco: MChatRiscoEnum | undefined
  mChatAtualPerguntasFalhas: ReadonlyArray<MChatPerguntaPrincipal>
  mChatAnteriorPerguntasFalhas: ReadonlyArray<MChatPerguntaPrincipal>
  isConsultaSeguimentoDesatualizada: boolean
}

export function ConsultaSeguimentoField(props: Readonly<ConsultaSeguimentoFieldProps>) {
  const {
    name,
    valuesAtendimentoAnterior,
    mChatAtualRisco,
    mChatAnteriorRisco,
    mChatAtualPerguntasFalhas,
    mChatAnteriorPerguntasFalhas,
    isConsultaSeguimentoDesatualizada,
  } = props

  const match = useRouteMatch()
  const modalConsultaSeguimentoUrl = `${match.url}${CONSULTA_SEGUIMENTO_URL_MODAL}`
  const aplicarButtonRef = useRef<HTMLButtonElement>(null)

  const {
    input: { value, onChange },
  } = usePecField({ name, subscription: { value: true } })

  const handleSave = (values: ConsultaSeguimentoFieldModel) => {
    const resultado = calculateResultadoConsultaSeguimento(values.aplicacao)
    onChange({ ...values, resultado })
  }

  const handleDelete = () => {
    onChange(null)
  }

  const mChatForConsultaSeguimento = getMChatForConsultaSeguimento(
    mChatAtualRisco,
    mChatAnteriorRisco,
    mChatAtualPerguntasFalhas,
    mChatAnteriorPerguntasFalhas
  )

  return (
    <Fragment>
      <ConsultaSeguimentoFieldAccordionSection
        name={name}
        valuesAtendimentoAnterior={valuesAtendimentoAnterior}
        modalUrl={modalConsultaSeguimentoUrl}
        mChatAtualRisco={mChatAtualRisco}
        mChatAnteriorRisco={mChatAnteriorRisco}
        aplicarButtonRef={aplicarButtonRef}
        isConsultaSeguimentoDesatualizada={isConsultaSeguimentoDesatualizada}
        onDelete={handleDelete}
      />

      <PrivateRoute cbos={NIVEL_SUPERIOR} path={modalConsultaSeguimentoUrl} exact>
        <ConsultaSeguimentoAplicacaoForm
          valueInCache={value}
          mChatRisco={mChatForConsultaSeguimento.risco}
          mChatPerguntasFalhas={mChatForConsultaSeguimento.perguntasFalhas}
          aplicarButtonRef={aplicarButtonRef}
          isConsultaSeguimentoDesatualizada={isConsultaSeguimentoDesatualizada}
          onSubmit={handleSave}
        />
      </PrivateRoute>
    </Fragment>
  )
}
